import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const CalendarComponent = ({ onMonthYearSelect, onClose }) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  
  const [monthSelected, setMonthSelected] = useState(false);
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  const currentMonth = monthNames[currentDate.getMonth()];
  
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [hoveredMonth, setHoveredMonth] = useState(null);
  const [hoveredYear, setHoveredYear] = useState(null);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [displayedYears, setDisplayedYears] = useState({
    prev: currentYear - 1,
    current: currentYear,
    next: currentYear + 1
  });

  
  const monthGroups = [
    {
      season: '',
      gradient: 'linear-gradient(135deg, #22d3ee 0%, #3b82f6 100%)',
      months: ['Dec', 'Jan', 'Feb']
    },
    {
      season: '',
      gradient: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
      months: ['Mar', 'Apr', 'May']
    },
    {
      season: '',
      gradient: 'linear-gradient(135deg, #8b5cf6 0%, #ec4899 100%)',
      months: ['Jun', 'Jul', 'Aug']
    },
    {
      season: '',
      gradient: 'linear-gradient(135deg, #ec4899 0%, #22d3ee 100%)',
      months: ['Sep', 'Oct', 'Nov']
    }
  ];

  
  const gradientTextStyle = {
    background: 'linear-gradient(135deg, #22d3ee 0%, #3b82f6 50%, #8b5cf6 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    filter: 'drop-shadow(0 0 30px rgba(34, 211, 238, 0.3))'
  };

  
  const defaultDarkBg = 'linear-gradient(135deg, #1f2937 0%, #374151 50%, #000000 100%)';

  
  

  useEffect(() => {
  if (!monthSelected) return;
  const monthYear = `${selectedMonth}${selectedYear}`;
  if (monthYear) {
    onMonthYearSelect(monthYear);
  }
  const timer = setTimeout (() => {
    setMonthSelected(false);

  }, 300);
  
   return () => clearTimeout(timer);
}, [ monthSelected, selectedYear, selectedMonth]);

  const handleYearChange = (year) => {
    
    setSelectedYear(year);
  };

  const handleMonthSelect = (month) => {
    setMonthSelected(true);
    setSelectedMonth(month);
  };
const handleClose = () => {
  setSelectedMonth(null);
  setMonthSelected(false);
  onClose();
};
  const navigateYears = (direction) => {
    setDisplayedYears(prev => ({
      prev: prev.prev + direction,
      current: prev.current + direction,
      next: prev.next + direction
    }));
  };

  const getMonthButtonStyles = (month, gradient) => {
    const isActive = month === selectedMonth;
    const isHovered = month === hoveredMonth;
    
   
    let background = defaultDarkBg;
    if (isActive) {
      background = gradient; 
    } else if (isHovered && !isActive) {
      background = gradient; 
    }
    
    return {
      background: background,
      border: '1px solid #22d3ee',
      color: 'white',
      padding: '8px 14px',
      fontSize: '0.875rem',
      fontWeight: '500',
      borderRadius: '9999px',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      outline: 'none',
      boxShadow: (isActive || isHovered) ? '0 0 20px rgba(34, 211, 238, 0.4)' : '0 2px 4px rgba(0,0,0,0.3)',
      transform: (isActive || isHovered) ? 'scale(1.05)' : 'scale(1)'
    };
  };

  const getYearButtonStyles = (year) => {
    const isActive = year === selectedYear;
    const isHovered = year === hoveredYear;
    
    // Determine background
    let background = defaultDarkBg; // Default dark
    if (isActive) {
      background = 'linear-gradient(135deg, #22d3ee 0%, #3b82f6 50%, #8b5cf6 100%)'; // Selected gets gradient
    } else if (isHovered && !isActive) {
      background = 'linear-gradient(135deg, #22d3ee 0%, #3b82f6 50%, #8b5cf6 100%)'; // Hover gets gradient
    }
    
    return {
      background: background,
      color: 'white',
      padding: '10px 20px',
      fontSize: '1.1rem',
      fontWeight: '600',
      border: `1px solid ${(isActive || isHovered) ? '#22d3ee' : '#374151'}`,
      borderRadius: '9999px',
      margin: '0 5px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      outline: 'none',
      boxShadow: (isActive || isHovered) ? '0 0 25px rgba(34, 211, 238, 0.5)' : '0 2px 4px rgba(0,0,0,0.3)',
      transform: (isActive || isHovered) ? 'scale(1.1)' : 'scale(1)'
    };
  };

  const navButtonStyle = {
    background: defaultDarkBg,
    border: '1px solid #22d3ee',
    borderRadius: '50%',
    width: '36px',
    height: '36px',
    cursor: 'pointer',
    padding: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.3s ease',
    boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
  };

  return (
    <div style={{ marginTop: '2rem' }}>
      <div style={{
        margin: '20px 0',
        padding: '30px',
        background: 'linear-gradient(to-br, #1f2937, #111827, #000000)',
        borderRadius: '24px',
        border: '1px solid #22d3ee',
        boxShadow: '0 10px 40px rgba(0,0,0,0.5)'
      }}>
        
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px' }}>
            <button
              onClick={() => navigateYears(-1)}
              style={navButtonStyle}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.1)';
                e.currentTarget.style.boxShadow = '0 0 20px rgba(34, 211, 238, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.3)';
              }}
            >
              <ChevronLeft size={20} color="#22d3ee" />
            </button>
            
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                style={getYearButtonStyles(displayedYears.prev)}
                onClick={() => handleYearChange(displayedYears.prev)}
                onMouseEnter={() => setHoveredYear(displayedYears.prev)}
                onMouseLeave={() => setHoveredYear(null)}
              >
                {displayedYears.prev}
              </button>
              <button
                style={getYearButtonStyles(displayedYears.current)}
                onClick={() => handleYearChange(displayedYears.current)}
                onMouseEnter={() => setHoveredYear(displayedYears.current)}
                onMouseLeave={() => setHoveredYear(null)}
              >
                {displayedYears.current}
              </button>
              <button
                style={getYearButtonStyles(displayedYears.next)}
                onClick={() => handleYearChange(displayedYears.next)}
                onMouseEnter={() => setHoveredYear(displayedYears.next)}
                onMouseLeave={() => setHoveredYear(null)}
              >
                {displayedYears.next}
              </button>
            </div>
            
            <button
              onClick={() => navigateYears(1)}
              style={navButtonStyle}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.1)';
                e.currentTarget.style.boxShadow = '0 0 20px rgba(34, 211, 238, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.3)';
              }}
            >
              <ChevronRight size={20} color="#22d3ee" />
            </button>
          </div>
        </div>

        {/* Month Groups */}
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
          justifyContent: 'center'
        }}>
          {monthGroups.map((group, groupIndex) => (
            <div key={groupIndex} style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '10px'
            }}>
              <div style={{ display: 'flex', gap: '6px' }}>
                {group.months.map((month) => (
                  <button
                    key={month}
                    onClick={() => handleMonthSelect(month)}
                    onMouseEnter={() => setHoveredMonth(month)}
                    onMouseLeave={() => setHoveredMonth(null)}
                    style={getMonthButtonStyles(month, group.gradient)}
                  >
                    {month}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Selected Month/Year Display */}
        <div 
          onClick={handleClose}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '2px',
            padding: '7px 20px',
            margin: '20px 16px 1px',//top, left/right,bottom
            borderRadius: '14px',
            background: 'rgba(34, 211, 238, 0.1)',
            border: '1px solid rgba(34, 211, 238, 0.15)',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
          }}
        >
          <span style={{
              fontSize: '0.95rem',
              fontWeight: '600',
              ...gradientTextStyle
            }}>
            Close Navigation
              
            </span>
           <div style={{ 
              fontSize: '0.7rem', 
              color: 'rgba(148, 163, 184, 0.7)',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}>
            Tap to close navigation
             <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(148, 163, 184, 0.5)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 15 12 9 18 15" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarComponent;